/**
 * MODEL B — OPTIMAL MODEL (More conservative)
 * Strong weight on accumulation, acceleration, compression, liquidity quality
 * Heavy distribution penalty
 */
export function computeOptimalModel(features) {
  const f = normalize(features);

  const raw =
    f.accumulation * 2.5 +
    f.acceleration * 2.0 +
    f.compression * 2.0 +
    f.liquidity * 1.5 +
    f.absorption * 0.5 +
    f.divergence * 0.5 -
    f.distribution * 2.0;

  const optScore = clamp(raw, 0, 10);
  const optStage = getStage(optScore);

  return { optScore: round1(optScore), optStage };
}

function normalize(features) {
  return {
    accumulation: sigmoid(features.accumulation5d, 50000),
    acceleration: ((features.accelerationScore || 0) + 1) / 2,
    compression: features.compressionScore || 0,
    liquidity: features.liquidityScore || 0,
    absorption: features.absorptionScore || 0,
    divergence: features.divergenceScore || 0,
    distribution: features.distributionRiskScore || 0,
  };
}

function sigmoid(x, scale) {
  return 1 / (1 + Math.exp(-x / Math.max(scale, 1)));
}

function getStage(score) {
  if (score >= 8.5) return 'CONFIRMED';
  if (score >= 7.5) return 'BUILD';
  if (score >= 6.0) return 'EARLY';
  if (score >= 5.0) return 'WATCH';
  return 'NONE';
}

function clamp(v, min, max) {
  return Math.max(min, Math.min(max, v));
}

function round1(n) {
  return Math.round(n * 10) / 10;
}
